import React, { useState, useEffect } from "react";
import { FaClipboardList, FaPlus, FaMinus, FaUser, FaCalendarAlt, FaMapMarkerAlt, FaPhone, FaEnvelope, FaTint, FaHeart, FaBriefcase, FaFileAlt, FaCheckCircle } from "react-icons/fa";
import { FiUpload, FiCheckCircle } from "react-icons/fi";
import handleApiError from "./handleApiError";
import toast from "react-hot-toast";
import authManager from "../../../utils/authManager";
import axios from "axios";
import FullScreenLoader from "../../ui/FullScreenLoader";
import PaymentOptions from "./PaymentOptions";
import { DASHBOARD_ROUTE, HOME_ROUTE } from "../../../routes/web/rootRoutes";
import { useNavigate } from "react-router-dom";

const MembershipApplicationCD = () => {
  const initialFormState = {
    date: "",
    name: "",
    address: "",
    dob: "",
    contactNo: "",
    email: "",
    bloodGroup: "",
    maritalStatus: "",
    workingWith: "",
    emergencyContact: "",
    experienceYears: "",
    experienceMonths: "",
    workExperience: "",
    references: [{ name: "", memberNo: "" }],
    agree: false,

    // FILES (ROOT LEVEL)
    member_photo: null,
    member_education_qualification: null,
    member_residential_address_proof: null,
    member_recent_photographs: null,
    member_reference_letter: null,
    member_health_certificate: null,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [photoPreview, setPhotoPreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
    const navigate = useNavigate(); 
  const [submissionResponse, setSubmissionResponse] = useState(null);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setFormData(prev => ({ ...prev, date: today }));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    // Clear field error when user types
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files[0],
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        member_photo: file,
      }));
      setPhotoPreview(URL.createObjectURL(file));
      if (errors.member_photo) {
        setErrors(prev => ({ ...prev, member_photo: null }));
      }
    }
  };

  const addReference = () => {
    setFormData(prev => ({
      ...prev,
      references: [...prev.references, { name: "", memberNo: "" }],
    }));
  };

  const removeReference = (index) => {
    setFormData(prev => ({
      ...prev,
      references: prev.references.filter((_, i) => i !== index),
    }));
  };

  const validateForm = () => {
    let temp = {};

    if (!formData.name?.trim()) temp.name = "Name is required";
    if (!formData.address?.trim()) temp.address = "Address is required";
   const dob = new Date(formData.dob);
const today = new Date();

const age = today.getFullYear() - dob.getFullYear();
const monthDiff = today.getMonth() - dob.getMonth();

if (!formData.dob) {
  temp.dob = "Date of birth is required";
} else if (isNaN(dob.getTime())) {
  temp.dob = "Please enter a valid date";
} else if (dob > today) {
  temp.dob = "Date of birth cannot be in the future";
} else if (age < 18 || (age === 18 && monthDiff < 0)) {
  temp.dob = "You must be at least 18 years old";
}

    if (!/^[0-9]{10}$/.test(formData.contactNo))
      temp.contactNo = "Valid 10-digit contact number required";
    if (!/\S+@\S+\.\S+/.test(formData.email))
      temp.email = "Valid email required";
    if (!formData.bloodGroup) temp.bloodGroup = "Blood group required";
    if (!formData.maritalStatus) temp.maritalStatus = "Marital status required";
    if (!formData.workingWith?.trim()) temp.workingWith = "Working organization required";
    if (!/^[0-9]{10}$/.test(formData.emergencyContact))
      temp.emergencyContact = "Valid emergency contact required";
    if (!formData.experienceYears && !formData.experienceMonths)
      temp.experience = "Experience required";
    if (!formData.workExperience?.trim())
      temp.workExperience = "Work experience required";

    if (!formData.member_photo)
      temp.member_photo = "Applicant photo required";
    if (!formData.member_education_qualification)
      temp.member_education_qualification = "Qualification file required";
    if (!formData.member_residential_address_proof)
      temp.member_residential_address_proof = "Address proof required";
    if (!formData.member_recent_photographs)
      temp.member_recent_photographs = "Recent photographs required";
    if (!formData.member_reference_letter)
      temp.member_reference_letter = "Reference letter required";
    if (!formData.member_health_certificate)
      temp.member_health_certificate = "Health certificate required";

    formData.references.forEach((ref, i) => {
      if (!ref.name?.trim() || !ref.memberNo?.trim())
        temp[`ref${i}`] = `Reference ${i + 1} details required`;
    });

    if (!formData.agree)
      temp.agree = "You must agree before submitting";

    return temp;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fill all required fields correctly");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    setIsSubmitting(true);
    try {
      const form = new FormData();

      form.append("date", formData.date);
      form.append("name", formData.name);
      form.append("address", formData.address);
      form.append("dob", formData.dob);
      form.append("contact_number", formData.contactNo);
      form.append("emergency_contact_number", formData.emergencyContact);
      form.append("email", formData.email);
      form.append("blood_group", formData.bloodGroup);
      form.append("married_status", formData.maritalStatus);
      form.append("work_with", formData.workingWith);
      form.append("experience_years", formData.experienceYears || "0");
      form.append("experience_months", formData.experienceMonths || "0");
      form.append("work_experience", formData.workExperience);
      form.append("form_type", "cd");

      formData.references.forEach((ref, index) => {
        form.append(`references[${index}]`, `${ref.name} - ${ref.memberNo}`);
      });

      form.append("member_photo", formData.member_photo);
      form.append("member_education_qualification", formData.member_education_qualification);
      form.append("member_residential_address_proof", formData.member_residential_address_proof);
      form.append("member_recent_photographs", formData.member_recent_photographs);
      form.append("member_reference_letter", formData.member_reference_letter);
      form.append("member_health_certificate", formData.member_health_certificate);

      const token = authManager.getAccessToken();
      if (!token) {
        toast.error("Authentication token not found. Please login again.");
        setIsSubmitting(false);
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}new-ad`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          timeout: 30000,
        }
      );

      toast.success("Membership Application submitted successfully!");
      setSubmissionResponse(response.data);
      setPhotoPreview(null);
      
      // Reset form but keep the date
      setFormData({
        ...initialFormState,
        date: formData.date,
      });

      // Show payment options after a short delay
      setTimeout(() => {
            navigate(DASHBOARD_ROUTE);

        setIsSubmitting(false);
        setShowPayment(true);
      }, 1500);

    } catch (error) {
      console.error("Submission error:", error);
      handleApiError(error, setErrors, "Submission failed");
      setIsSubmitting(false);
    }
  };

  const handleClosePayment = () => {
    setShowPayment(false);
    window.location.href = HOME_ROUTE;
  };

  if (showPayment) {
    return <PaymentOptions onClose={handleClosePayment} />;
  }

  return (
    <>
      {isSubmitting && <FullScreenLoader message="Submitting your application..." />}

      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-purple-700 via-violet-600 to-indigo-700 text-white px-6 py-8 text-center">
              <h1 className="text-3xl md:text-4xl font-bold mb-2">NEW MEMBERSHIP APPLICATION</h1>
              <p className="text-lg opacity-90">Costume Department</p>
            </div>

            <form onSubmit={handleSubmit} className="p-6 md:p-10 space-y-8">
              {/* Section: Member & Date */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border-l-4 border-indigo-500">
                <div className="space-y-2">
                  <label className="flex items-center text-sm font-semibold text-gray-700">
                    <FaUser className="mr-2 text-indigo-600" /> Applicant Name <span className="text-red-500 ml-1">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter full name"
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none transition ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
                  />
                  {errors.name && <p className="text-xs text-red-500 mt-1">{errors.name}</p>}
                </div>

                <div className="space-y-2">
                  <label className="flex items-center text-sm font-semibold text-gray-700">
                    <FaCalendarAlt className="mr-2 text-indigo-600" /> Date <span className="text-red-500 ml-1">*</span>
                  </label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    readOnly
                    className="w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-lg cursor-not-allowed"
                  />
                </div>
              </div>

              {/* To Section */}
              <div className="p-5 bg-gray-50 border-l-4 border-indigo-400 rounded-lg">
                <p className="font-semibold text-gray-800">To,</p>
                <p className="text-gray-700">The President / General Secretary</p>
                <p className="text-gray-700">Association of Cine & Television Art Directors & Costume Designers</p>
              </div>

              {/* Personal Details */}
              <div className="space-y-6 p-6 bg-green-50 rounded-xl border-l-4 border-green-500">
                <h2 className="text-xl font-bold text-gray-800 flex items-center">
                  <FaUser className="mr-2 text-green-600" /> Personal Details
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2 md:col-span-2">
                    <label className="block text-sm font-semibold text-gray-700">Residential Address <span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder="Enter complete address"
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none ${errors.address ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.address && <p className="text-xs text-red-500">{errors.address}</p>}
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Date of Birth <span className="text-red-500">*</span></label>
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none ${errors.dob ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.dob && <p className="text-xs text-red-500">{errors.dob}</p>}
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Contact No <span className="text-red-500">*</span></label>
                    <input
                      type="tel"
                      name="contactNo"
                      value={formData.contactNo}
                      onChange={handleChange}
                      placeholder="10-digit mobile number"
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none ${errors.contactNo ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.contactNo && <p className="text-xs text-red-500">{errors.contactNo}</p>}
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Email ID <span className="text-red-500">*</span></label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="your@email.com"
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.email && <p className="text-xs text-red-500">{errors.email}</p>}
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Blood Group <span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      name="bloodGroup"
                      value={formData.bloodGroup}
                      onChange={handleChange}
                      placeholder="e.g., O+"
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none ${errors.bloodGroup ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.bloodGroup && <p className="text-xs text-red-500">{errors.bloodGroup}</p>}
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Marital Status <span className="text-red-500">*</span></label>
                    <select
                      name="maritalStatus"
                      value={formData.maritalStatus}
                      onChange={handleChange}
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none ${errors.maritalStatus ? 'border-red-500' : 'border-gray-300'}`}
                    >
                      <option value="">Select</option>
                      <option value="Married">Married</option>
                      <option value="Unmarried">Unmarried</option>
                    </select>
                    {errors.maritalStatus && <p className="text-xs text-red-500">{errors.maritalStatus}</p>}
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Presently Working With <span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      name="workingWith"
                      value={formData.workingWith}
                      onChange={handleChange}
                      placeholder="Company / Organization"
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none ${errors.workingWith ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.workingWith && <p className="text-xs text-red-500">{errors.workingWith}</p>}
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Emergency Contact No <span className="text-red-500">*</span></label>
                    <input
                      type="tel"
                      name="emergencyContact"
                      value={formData.emergencyContact}
                      onChange={handleChange}
                      placeholder="10-digit emergency number"
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none ${errors.emergencyContact ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.emergencyContact && <p className="text-xs text-red-500">{errors.emergencyContact}</p>}
                  </div>
                </div>
              </div>

              {/* Experience Section */}
              <div className="p-6 bg-yellow-50 rounded-xl border-l-4 border-yellow-500">
                <h2 className="text-xl font-bold text-gray-800 flex items-center mb-4">
                  <FaBriefcase className="mr-2 text-yellow-600" /> Industry Experience
                </h2>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">For how long you have been in this industry <span className="text-red-500">*</span></label>
                    <div className="flex flex-wrap gap-4">
                      <input
                        type="number"
                        name="experienceYears"
                        placeholder="Years"
                        value={formData.experienceYears}
                        onChange={handleChange}
                        min="0"
                        className="w-28 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                      />
                      <input
                        type="number"
                        name="experienceMonths"
                        placeholder="Months"
                        value={formData.experienceMonths}
                        onChange={handleChange}
                        min="0"
                        max="11"
                        className="w-28 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                      />
                    </div>
                    {errors.experience && <p className="text-xs text-red-500 mt-1">{errors.experience}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Work Experiences <span className="text-red-500">*</span></label>
                    <textarea
                      name="workExperience"
                      value={formData.workExperience}
                      onChange={handleChange}
                      rows="4"
                      placeholder="Describe your professional experience"
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none ${errors.workExperience ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.workExperience && <p className="text-xs text-red-500 mt-1">{errors.workExperience}</p>}
                  </div>
                </div>
              </div>

              {/* Photo Upload */}
              <div className="p-6 bg-red-50 rounded-xl border-l-4 border-red-400">
                <h2 className="text-xl font-bold text-gray-800 flex items-center mb-4">
                  <FiUpload className="mr-2 text-red-500" /> Applicant Photo
                </h2>
                <div className="flex flex-col sm:flex-row items-start gap-6">
                  <div className="flex-1">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handlePhotoChange}
                      className="w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-red-100 file:text-red-700 hover:file:bg-red-200"
                    />
                    {errors.member_photo && <p className="text-xs text-red-500 mt-1">{errors.member_photo}</p>}
                  </div>
                  {photoPreview && (
                    <img src={photoPreview} alt="Preview" className="w-32 h-32 object-cover rounded-lg border-4 border-white shadow-md" />
                  )}
                </div>
              </div>

              {/* References Section */}
              <div className="p-6 bg-purple-50 rounded-xl border-l-4 border-purple-500">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-xl font-bold text-gray-800 flex items-center">
                    <FaClipboardList className="mr-2 text-purple-600" /> References
                  </h2>
                  <button
                    type="button"
                    onClick={addReference}
                    className="flex items-center px-3 py-1.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition text-sm font-medium"
                  >
                    <FaPlus className="mr-1" /> Add Reference
                  </button>
                </div>

                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Sr. No.</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Name</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Member No.</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Action</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {formData.references.map((ref, index) => (
                        <tr key={index}>
                          <td className="px-4 py-2 text-sm text-gray-700">{index + 1}</td>
                          <td className="px-4 py-2">
                            <input
                              type="text"
                              value={ref.name}
                              onChange={(e) => {
                                const updated = [...formData.references];
                                updated[index].name = e.target.value;
                                setFormData(prev => ({ ...prev, references: updated }));
                              }}
                              placeholder="Name"
                              className="w-full px-2 py-1 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 outline-none text-sm"
                            />
                          </td>
                          <td className="px-4 py-2">
                            <input
                              type="text"
                              value={ref.memberNo}
                              onChange={(e) => {
                                const updated = [...formData.references];
                                updated[index].memberNo = e.target.value;
                                setFormData(prev => ({ ...prev, references: updated }));
                              }}
                              placeholder="Member No."
                              className="w-full px-2 py-1 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 outline-none text-sm"
                            />
                          </td>
                          <td className="px-4 py-2">
                            {formData.references.length > 1 && (
                              <button
                                type="button"
                                onClick={() => removeReference(index)}
                                className="text-red-600 hover:text-red-800"
                              >
                                <FaMinus />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {formData.references.map((_, i) => errors[`ref${i}`] && (
                  <p key={i} className="text-xs text-red-500 mt-1">{errors[`ref${i}`]}</p>
                ))}
              </div>

              {/* Documents Upload Section */}
              <div className="p-6 bg-indigo-50 rounded-xl border-l-4 border-indigo-500">
                <h2 className="text-xl font-bold text-gray-800 flex items-center mb-4">
                  <FaFileAlt className="mr-2 text-indigo-600" /> Documents & Files Upload
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {[
                    { label: "Education / Technical Qualification", name: "member_education_qualification" },
                    { label: "Residential Address Proof (Aadhar / Passport / Ration Card)", name: "member_residential_address_proof" },
                    { label: "Recent Passport Size Photographs (2 Nos.)", name: "member_recent_photographs" },
                    { label: "Reference Letter from 3 Art Directors", name: "member_reference_letter" },
                    { label: "Health Certificate", name: "member_health_certificate" },
                  ].map((doc, idx) => (
                    <div key={doc.name} className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">
                        {idx + 1}. {doc.label} <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="file"
                        name={doc.name}
                        onChange={handleFileChange}
                        className="w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-indigo-100 file:text-indigo-700 hover:file:bg-indigo-200"
                      />
                      {errors[doc.name] && <p className="text-xs text-red-500">{errors[doc.name]}</p>}
                    </div>
                  ))}
                </div>
              </div>

              {/* Terms and Conditions */}
              <div className="p-6 bg-gray-50 rounded-xl border-2 border-gray-200">
                <h2 className="text-xl font-bold text-gray-800 flex items-center mb-4">
                  <FaCheckCircle className="mr-2 text-green-600" /> Terms and Conditions
                </h2>
                <ul className="list-decimal pl-5 space-y-2 text-sm text-gray-700">
                  <li>Once the applicant for membership has been approved by the executive committee, the applicant must comply with all payment formalities within one month.</li>
                  <li>Amount paid by the applicant is non-refundable.</li>
                  <li>If the applicant uses the installment facility, he/she must submit all Post-Dated Cheques (PDC) along with the application.</li>
                  <li>PDCs submitted by the applicant must be duly honored. If any PDC is not realized for more than two months, the application will be treated as cancelled. The amount paid will be forfeited and transferred to the ACTADCD welfare fund. A fresh application will be required.</li>
                  <li>ACTADCD will not entertain any dispute from the applicant until a membership number is issued. The applicant will not have voting rights until he/she receives the membership number.</li>
                  <li>Membership card and ACTADCD benefits will be provided <strong>only after full payment is completed</strong>.</li>
                  <li>All payments should be made in favor of <strong>ACTADCD</strong>.</li>
                </ul>

                <div className="flex items-center mt-6">
                  <input
                    type="checkbox"
                    id="agree"
                    name="agree"
                    checked={formData.agree}
                    onChange={handleChange}
                    className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                  />
                  <label htmlFor="agree" className="ml-2 text-sm text-gray-700">
                    I agree to the Terms & Conditions. <span className="text-red-500">*</span>
                  </label>
                </div>
                {errors.agree && <p className="text-xs text-red-500 mt-1">{errors.agree}</p>}
              </div>

              {/* Submit Button */}
              <div className="flex justify-end pt-4">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-8 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-lg shadow-md hover:from-purple-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Application'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default MembershipApplicationCD;